export const numberFormat = (value) =>
    new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(value);

export const numberPerCentageFormat = (value) =>
    new Intl.NumberFormat({
        floatValue: value | undefined,
        formattedValue: value,
        value: value
    }).format(value.toFixed(2));

// export interface NumberFormatValues {
// floatValue: number | undefined;
// formattedValue: string;
// value: string;
// }
